<template>
  <header class="main-header">
    <a href="/home" class="logo">
      <span class="logo-mini">
          <img class="img-responsive center-block" src="/static/img/logo/logo-mini.svg">
        </span>
      <span class="logo-lg">
        <img class="img-responsive center-block" src="/static/img/logo/logo-lg.svg">
      </span>
    </a>
    <nav class="navbar navbar-static-top" role="navigation">
      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li class="dropdown messages-menu hidden">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-envelope-o"></i>
              <span class="label label-success"></span>
            </a>
            <ul class="dropdown-menu">
              <li class="header"></li>
              <li v-if="state.userInfo && state.userInfo.messages.length > 0">
                <ul class="menu">
                  <li>
                    <a href="javascript:;">
                      <h4>
                        Support Team
                        <small><i class="fa fa-clock-o"></i> 5 mins</small>
                      </h4>
                      <p>Why not consider this a test message?</p>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer" v-if="state.userInfo && state.userInfo.messages.length > 0"><a href="javascript:;">See All Messages</a></li>
            </ul>
          </li>
          <li class="dropdown notifications-menu hidden">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-bell-o"></i>
              <span v-if="labelErrors.length > 0" class="label label-warning">{{labelErrors.length}}</span>
            </a>
          </li>
          <li class="dropdown tasks-menu hidden">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-flag-o"></i>
              <span class="label label-danger"></span>
            </a>
            <ul class="dropdown-menu">
              <li class="header"></li>
              <li v-if="state.userInfo && state.userInfo.tasks.length > 0">
                <ul class="menu">
                  <li>&lt;!&ndash; Task item &ndash;&gt;
                    <a href="javascript:;">
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer" v-if="state.userInfo && state.userInfo.tasks.length > 0">
                <a href="javascript:;">View all tasks</a>
              </li>
            </ul>
          </li>
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-user-o"></i>
              <span class="hidden-xs">{{user.username}}</span>
            </a>
            <ul class="dropdown-menu">
              <li class="user-header">
                <p>{{user.username}}<small>{{user.first_name}} {{user.last_name}}</small></p>
              </li>
              <!--<li class="user-body">
                <div class="row">
                  <div class="col-xs-12 text-center">
                    <div class="btn-group">
                      <button type="button" class="btn disabled">Language</button>
                      <button type="button" class="btn active"><img class="center-block" src="/static/img/language/de.png" alt="German" title="Change Sprache"></button>
                      <button type="button" class="btn"><img class="center-block" src="/static/img/language/en.png" alt="English" title="Change Sprache"></button>
                      <button type="button" class="btn"><img class="center-block" src="/static/img/language/es.png" alt="Spanish" title="Change Sprache"></button>
                    </div>
                  </div>
                </div>
              </li>-->
              <hr/>
              <li class="user-footer">
                <!--<div class="pull-left">
                  <a disabled href="user-account.html" class="btn btn-default disabled"><i class="fa fa-user-circle mr-5"></i> Account</a>
                </div>-->
                <div class="text-center">
                  <a disabled href="lockscreen.html" class="btn btn-default disabled"><i class="fa fa-lock"></i></a>
                  <button type="button" @click="$store.dispatch('logout')" class="btn btn-default">Logoff <i class="fa fa-power-off ml-5"></i></button>
                </div>
              </li>
            </ul>
          </li>
          <!--<b-nav-item-dropdown right class="user user-menu">
            <template v-slot:button-content>
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <img :src="`/static/img/${user_image}`" class="user-image" alt="User Image">
                <span class="hidden-xs">{{ user.company }}</span>
              </a>
            </template>
          </b-nav-item-dropdown>-->
          <li v-if="!allFalse(user)">
            <a class="" @click="$store.commit('toggleSidebar')" href="#"><i class="fa fa-gears"></i></a>
          </li>
         <!-- <b-nav-item @click="$store.dispatch('logout')"><span class="text-bold text-danger"><i class="fa fa-sign-out mr-5"></i> Ausloggen</span></b-nav-item>-->
        </ul>
      </div>
    </nav>
  </header>
</template>
<script>
  export default {
    name: 'TopBar',
    props: ['state'],
    data () {
      return {
        language: 'de',
        labelErrors: [],
        user: this.$store.getters.user,
        user_image: 'user2-160x160.jpg', // NEED THIS FROM DATABASE
        user_position: 'best front-end developer ever', // THIS TOO
      }
    },
    methods: {
      checkEnv () {
        return ['qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de'].indexOf(window.location.hostname) !== -1
      },
      allFalse (user) {
          for (let i in user.admin) {
            if (user.admin[i] === true) return false
          }
          return true
      },
      changeLanguage (lang) {
        this.$store.commit('updateLanguage', lang)
        this.language = lang
      }
    }
  }
</script>
<style></style>
